const translations = {
  en: {
    // ── Language picker popup ──
    langPickerTitle: 'Choose your language',
    langPickerSubtitle: 'You can change this anytime',

    // ── Nav (shared) ──
    navCrm: 'CRM',
    navTemplates: 'Templates',
    navBrandKit: 'Brand Kit',
    navGenerator: 'Generator',
    navPipeline: 'Pipeline',
    navMetaCampaigns: 'Meta Campaigns',
    navMetaAds: 'Meta Ads',
    navEditor: 'Editor',
    navLogout: 'Log out',
    navCopyLink: 'Copy link',
    navCopied: '✓ Copied',
    navStableLiveLink: 'Stable live link',
    langToggle: '🌐',

    // ── HomePage: Hero ──
    heroMicro: 'AI Career Page Studio - Built for HR teams',
    heroLine1: 'PUBLISH',
    heroLine2: 'CAREER',
    heroLine3: 'PAGES IN 30s',
    heroSub: 'Fill in your job details and get a live, branded recruiting page - complete with an application form - ready to share instantly.',
    statPagesDeployed: 'Pages deployed',
    statFillRate: 'Fill rate improvement',
    statAvgPublish: 'Avg. publish time',
    statMoreApplicants: 'More applicants',

    // ── HomePage: Form stages ──
    formTitle: 'Role brief wizard',
    formStepOf: 'Step {current} of {total}',
    stage1Title: 'Role essentials',
    stage1Sub: 'Core role and logistics',
    stage2Title: 'Content brief',
    stage2Sub: 'Requirements, benefits, and tone',
    stage3Title: 'Brand and launch',
    stage3Sub: 'Palette, lock, and provider',

    // ── Stage 1 fields ──
    labelJobTitle: 'Role title',
    placeholderJobTitle: 'e.g. Senior React Developer',
    labelCompany: 'Company',
    placeholderCompany: 'Acme Labs',
    labelSalary: 'Salary range',
    placeholderSalary: 'USD 80k - 110k',
    labelLocation: 'Location',
    placeholderLocation: 'Berlin / Remote',
    labelSeniority: 'Seniority level',
    seniorityJunior: 'Junior',
    seniorityMid: 'Mid-level',
    senioritySenior: 'Senior',
    seniorityLead: 'Lead / Staff',
    seniorityDirector: 'Director',
    labelEmploymentType: 'Type',
    typeFull: 'Full-time',
    typePart: 'Part-time',
    typeContract: 'Contract',
    typeInternship: 'Internship',
    labelWorkMode: 'Work mode',
    modeOnsite: 'Onsite',
    modeHybrid: 'Hybrid',
    modeRemote: 'Remote',

    // ── Stage 2 fields ──
    labelPageStyle: 'Page style',
    labelRequirements: 'Key requirements',
    placeholderRequirements: 'React, TypeScript, 4+ years experience, strong communication...',
    labelQualifications: 'Qualifications',
    placeholderQualifications: 'Bachelor\'s in CS or related field, AWS certified, PMP certification preferred...',
    labelEmployerBranding: 'Employer branding',
    placeholderEmployerBranding: 'We\'re a mission-driven team building the future of work. Fast-growing, remote-first culture with high ownership...',
    labelBenefits: 'Benefits & perks',
    placeholderBenefits: 'ESOPs, flexible hours, learning budget, health cover...',

    // ── Stage 3 fields ──
    labelLogoUrl: 'Brand Logo',
    placeholderLogoUrl: 'https://cdn.example.com/logo.png',
    logoUploadBtn: 'Upload Logo',
    logoUploading: 'Uploading…',
    logoUploadHint: 'PNG, JPG, SVG, WebP — max 5 MB',
    logoChangeBtn: 'Change',
    logoRemoveBtn: 'Remove',
    logoRequired: 'Brand logo is required. Please upload your company logo.',
    labelBrandColors: 'Brand Colors',
    labelDesignLock: 'Design lock',
    designLockLabel: 'Keep brand palette fixed during generation and edits',
    labelPrimaryColor: 'Primary Color',
    labelSecondaryColor: 'Secondary Color',
    labelAccentColor: 'Accent Color',

    // ── Form footer / buttons ──
    footerHint: 'Live page in ~30 seconds',
    btnBack: '← Back',
    btnNextStep: 'Next step →',
    btnGenerate: 'Generate career page',

    // ── Generation phases ──
    phase1: 'Validating job brief',
    phase2: 'Building page structure',
    phase3: 'Composing sections and form',
    phase4: 'Applying brand direction',
    phase5: 'Publishing live draft',

    // ── Morph strip ──
    morphLabel: 'Now hiring for',

    // ── Footer ──
    footerTagline: 'AI-powered career pages that convert. Built for modern HR teams who move fast.',
    footerProduct: 'Product',
    footerResources: 'Resources',
    footerCompany: 'Company',
    footerAnalytics: 'Analytics',
    footerDocs: 'Documentation',
    footerApiRef: 'API Reference',
    footerChangelog: 'Changelog',
    footerAbout: 'About',
    footerPrivacy: 'Privacy Policy',
    footerTerms: 'Terms & Conditions',
    footerImprint: 'Imprint',
    footerCopy: '© 2026 Formly HR · AI career pages for hiring teams',
    footerStatus: 'All systems operational',

    // ── Auth page ──
    authWelcomeBack: 'Welcome back',
    authGetStarted: 'Get started free',
    authSignBackIn: 'SIGN\nBACK\nIN.',
    authBuildPages: 'BUILD\nPAGES\nFASTER.',
    authTagline: 'Your pages are waiting.\nDescriptions become live forms\nin under 30 seconds.',
    authPerk1: 'Live page deployed in ~30 seconds',
    authPerk2: 'Edit anything by chatting — no code needed',
    authPerk3: 'Form submissions collected automatically',
    authPerk4: 'Free to start. No credit card required.',
    authAuthentication: 'Authentication',
    authCreateAccount: 'Create account',
    authLoginTitle: 'Log in to Formly',
    authSignupTitle: 'Start building free',
    authEmailLabel: 'Email address',
    authEmailPlaceholder: 'you@company.com',
    authPasswordLabel: 'Password',
    authForgotPassword: 'forgot password?',
    authPwMin: 'Min 8 characters',
    authPwWeak: 'Weak',
    authPwOkay: 'Okay',
    authPwStrong: 'Strong',
    authPwVeryStrong: 'Very strong',
    authResetPasswordSent: 'If the email exists, a reset link has been sent.',
    authResetLinkSent: 'If the email exists, a reset link has been sent.',
    authResetPasswordTitle: 'Reset your password',
    authResetPasswordNote: 'Enter a new password to complete the reset.',
    authNewPasswordLabel: 'New password',
    authNewPasswordPlaceholder: 'Create a new password',
    authConfirmPasswordLabel: 'Confirm password',
    authConfirmPasswordPlaceholder: 'Re-enter your password',
    authPasswordMismatch: 'Passwords do not match.',
    authPasswordResetSuccess: 'Your password has been updated.',
    authBackToLogin: 'Back to login',
    authTermsAgree: 'I agree to the',
    authTermsOfService: 'Terms of Service',
    authPrivacyPolicy: 'Privacy Policy',
    authSignIn: 'Sign in',
    authCreateAccountBtn: 'Create account',
    authPleaseWait: 'Please wait...',
    authOrContinue: 'or continue with',
    authContinueGoogle: 'Continue with Google',
    authContinueGithub: 'Continue with GitHub',
    authNoAccount: 'No account?',
    authHaveAccount: 'Already have an account?',
    authCreateOne: 'Create one →',
    authSignInLink: 'Sign in →',
    authStepAccount: 'Account',
    authStepDetails: 'Details',
    authStepDone: 'Done',
    authStepLabel: 'Step {current} of {total} — {label}',

    // ── Editor page ──
    editorLivePreview: 'Live preview',
    editorLive: '● live',
    editorStableUrl: 'Stable URL:',
    editorDiffView: 'Edits — diff view',
    editorPlaceholder: 'Request a change, upload media, or generate an image...',
    editorApply: '→ Apply',
    editorApplying: 'Applying...',
    editorOverrideDesignLock: 'Override design lock for this edit',
    editorBrandKit: 'Brand kit',
    editorBrandLogoLabel: 'Brand logo URL',
    editorBrandLogoPlaceholder: 'https://cdn.example.com/logo.png',
    editorPrimary: 'Primary',
    editorSecondary: 'Secondary',
    editorAccent: 'Accent',
    editorKeepBrandLock: 'Keep brand palette locked',
    editorSaveBrand: 'Save brand metadata',
    editorSavingBrand: 'Saving...',
    editorMediaAssets: 'Media assets',
    editorUploadImage: 'Upload image/video',
    editorUploading: '⏳ Uploading...',
    editorAiImagePlaceholder: 'e.g. "Real photo: physiotherapist treating patient, bright clinic, DSLR, natural light, not CGI"',
    editorGenerate: 'Generate',
    editorClose: 'Close',
    editorNoAssets: 'No assets uploaded yet.',
    editorUse: '↗ Use',
    editorRemove: '✕ Remove',
    editorInitialMsg: 'Live page loaded. Describe your first change to begin editing.',

    // ── CRM page ──
    crmCreateJob: 'Create Job',
    crmJobTitle: 'Job title',
    crmCompany: 'Company',
    crmLocation: 'Location',
    crmSalaryRange: 'Salary range',
    crmSaving: 'Saving...',
    crmPipelineSnapshot: 'Pipeline Snapshot',
    crmCandidates: 'Candidates',
    crmAllJobs: 'All jobs',
    crmAllStages: 'All stages',
    crmClearJobFilter: 'Clear Job Filter',
    crmSearchPlaceholder: 'Search by name, email, phone, page, or job',
    crmSearch: 'Search',
    crmClearSearch: 'Clear Search',
    crmShowingFor: 'Showing candidates who applied through: {title}',
    crmShowingAll: 'Showing all candidates from all landing pages.',
    crmShowingCount: 'Showing {count} of {total} candidates.',
    crmLoading: 'Loading...',
    crmNoCandidates: 'No candidates yet. Submit your generated form to start the pipeline.',
    crmThName: 'Name',
    crmThEmail: 'Email',
    crmThPhone: 'Phone',
    crmThJob: 'Job',
    crmThSourcePage: 'Source Page',
    crmThLiveUrl: 'Live URL',
    crmThStage: 'Stage',
    crmOpenPage: 'Open page',
    crmUnknown: 'Unknown',
    crmUnassigned: 'Unassigned',
    crmPrev: 'Prev',
    crmNext: 'Next',
    crmPage: 'Page {current} / {total}',
    crmCandidateDetails: 'Candidate Details',
    crmClose: 'Close',
    crmLoadingDetails: 'Loading details...',
    crmName: 'Name:',
    crmEmail: 'Email:',
    crmPhone: 'Phone:',
    crmJob: 'Job:',
    crmStage: 'Stage:',
    crmAssignee: 'Assignee',
    crmAssigneePlaceholder: 'Recruiter name or owner',
    crmNotes: 'Notes',
    crmNotesPlaceholder: 'Add candidate notes',
    crmSaveDetails: 'Save Details',
    crmTimeline: 'Timeline',
    crmNoEvents: 'No events yet.',
    crmOriginalPayload: 'Original Form Payload',
    crmJobRequired: 'Job title is required',
    crmJobCreated: 'Job created successfully.',
    crmStageUpdated: 'Candidate stage updated.',
    crmDetailsSaved: 'Candidate details saved.',

    // ── Meta Campaign page ──
    metaTotalCampaigns: 'Total Campaigns',
    metaActiveNow: 'Active Now',
    metaCombinedBudget: 'Combined Daily Budget',
    metaLandingPagesLinked: 'Landing Pages Linked',
    metaNewCampaign: 'New Campaign',
    metaDescription: 'Connect a landing page to Facebook & Instagram ads. AI generates ad copy from your page description automatically.',
    metaLandingPage: 'Landing Page',
    metaSelectPage: 'Select a page…',
    metaOrPasteUuid: 'Or paste page UUID',
    metaCampaignName: 'Campaign Name',
    metaCampaignNamePlaceholder: 'e.g. Senior Engineer — Q2 Hiring',
    metaAdAccountId: 'Ad Account ID',
    metaAdAccountPlaceholder: 'Numeric ID (without act_)',
    metaFbPageId: 'Facebook Page ID',
    metaFbPagePlaceholder: 'Your FB Business Page ID',
    metaAccessToken: 'Access Token',
    metaAccessTokenPlaceholder: 'Meta ads_management token',
    metaObjective: 'Objective',
    metaDailyBudget: 'Daily Budget',
    metaLaunchStatus: 'Launch Status',
    metaPaused: 'Paused — review first',
    metaActive: 'Active — launch now',
    metaAiForAdCopy: 'AI for Ad Copy',
    metaLaunchCampaign: 'Launch Campaign',
    metaCreatingOnMeta: 'Creating on Meta…',
    metaCampaignHistory: 'Campaign History',
    metaNoCampaigns: 'No campaigns yet. Create your first one above.',
    metaAiAdCopy: 'AI-Generated Ad Copy',
    metaHeadline: 'Headline',
    metaPrimaryText: 'Primary Text',
    metaAdDescription: 'Description',
    metaCampaignId: 'Meta Campaign ID',
    metaAdSetId: 'Ad Set ID',
    metaAdId: 'Ad ID',
    metaAdAccount: 'Ad Account',
    metaAdCopy: 'Ad Copy',
    metaCreatedSuccess: 'Campaign created on Meta — check your Ads Manager.',
    metaCreatedFail: 'Campaign creation failed',
    metaLeadGen: 'Lead Generation',
    metaTraffic: 'Traffic',
    metaBrandAwareness: 'Brand Awareness',
    metaTargetCountries: 'Target Countries',
    metaTargetCountriesPlaceholder: 'DE, AT, CH',
    metaTargetCountriesHint: 'ISO 2-letter codes, comma-separated (e.g. DE, AT, CH)',

    // ── CRM redesign ──
    crmMyDashboard: 'My Dashboard',
    crmMyLandingPages: 'My Landing Pages',
    crmStatusPublished: 'Published',
    crmStatusInReview: 'In Review',
    crmStatusPending: 'Pending',
    crmStepSubmitted: 'Request Submitted',
    crmStepReviewing: 'Admin Reviewing',
    crmStepLive: 'Page Live',
    crmTotalRequests: 'Total Requests',
    crmStatusBreakdown: 'Status Breakdown',
    crmLoadingPages: 'Loading your pages…',
    crmNoRequests: 'No requests yet',
    crmNoRequestsDesc: 'Submit a landing page request and track it here.',
    crmSubmitFirstRequest: 'Submit Your First Request →',
    crmNewRequest: '+ New Request',
    crmViewPage: 'View Page ↗',
    crmSubmitDate: 'Submitted',
    crmChartTotal: 'total',

    // ── Admin login ──
    adminPanelSub: 'Admin Panel',
    adminEmail: 'Email',
    adminPassword: 'Password',
    adminSignIn: 'Sign In',
    adminSigningIn: 'Signing in…',

    // ── Admin dashboard ──
    adminPendingRequests: 'Pending Requests',
    adminDraftPages: 'Draft Pages',
    adminPublished: 'Published',
    adminTotalPages: 'Total Pages',
    adminTabRequests: 'Page Requests',
    adminTabPages: 'All Pages',
    adminTabCandidates: 'Candidates',
    adminTabAnalytics: 'Analytics',
    adminAnalyticsTotalViews: 'Total Views',
    adminAnalyticsUniqueVisitors: 'Unique Visitors',
    adminAnalyticsToday: 'Views Today',
    adminAnalytics7d: 'Views (7 days)',
    adminAnalyticsPageBreakdown: 'Page Breakdown',
    adminAnalyticsLast7Days: 'Daily Views — Last 7 Days',
    adminAnalyticsNoData: 'No visits recorded yet. Share your published pages to start tracking.',
    adminAnalyticsColPage: 'Page',
    adminAnalyticsColUser: 'Owner',
    adminAnalyticsColTotal: 'Total Views',
    adminAnalyticsColUnique: 'Unique Visitors',
    adminAnalyticsColToday: 'Today',
    adminAnalyticsCol7d: '7 Days',
    adminLoading: 'Loading…',
    adminGenerate: 'Generate',
    adminGenerating: 'Generating…',
    adminDelete: 'Delete',
    adminEdit: 'Edit',
    adminPublish: 'Publish',
    adminUnpublish: 'Unpublish',
    adminRefresh: 'Refresh',
    adminExportCsv: 'Export CSV',
    adminExportJson: 'Export JSON',
    adminNoRequests: 'No pending requests.',
    adminNoPages: 'No pages found',
    adminNoCandidates: 'No candidates yet.',
    adminSearchPlaceholder: 'Search by description or user email…',
    adminCandSearchPlaceholder: 'Search by name, email, phone, or job…',
    adminSearch: 'Search',
    adminClearSearch: 'Clear',
    adminPrev: '← Prev',
    adminNext: 'Next →',
    adminColNum: '#',
    adminColUser: 'User',
    adminColDescription: 'Description',
    adminColStatus: 'Status',
    adminColCreated: 'Created',
    adminColLiveUrl: 'Live URL',
    adminColActions: 'Actions',
    adminColName: 'Name',
    adminColEmail: 'Email',
    adminColPhone: 'Phone',
    adminColJob: 'Job',
    adminColApplied: 'Applied',
    adminColStage: 'Stage',
    adminOpenPage: 'Open ↗',
    adminCandidateDetails: 'Candidate Details',
    adminClose: 'Close ✕',
    adminNotes: 'Notes:',
    adminTimeline: 'TIMELINE',
    adminLogout: 'Logout',
    adminNavPages: 'pages',
    adminNavPending: 'pending',
    adminToastPublished: 'Page published! User can now view it.',
    adminToastUnpublished: 'Page reverted to draft.',
    adminToastDeleted: 'Page deleted',
    adminConfirmDelete: 'Delete this page? This cannot be undone.',
    adminPageOf: 'Page {page} · {total} total',

    // ── HomePage success state ──
    homeRequestSubmitted: 'Request Submitted!',
    homeRequestBody: 'Your landing page request has been received. The admin will review and publish it shortly.',
    homeSubmitAnother: 'Submit Another',
    homeViewInCrm: 'View in CRM →',
    homeSubmittingRequest: 'Submitting request…',
  },

  de: {
    // ── Language picker popup ──
    langPickerTitle: 'Sprache wählen',
    langPickerSubtitle: 'Sie können dies jederzeit ändern',

    // ── Nav (shared) ──
    navCrm: 'CRM',
    navTemplates: 'Vorlagen',
    navBrandKit: 'Marken-Kit',
    navGenerator: 'Generator',
    navPipeline: 'Pipeline',
    navMetaCampaigns: 'Meta-Kampagnen',
    navMetaAds: 'Meta Ads',
    navEditor: 'Editor',
    navLogout: 'Abmelden',
    navCopyLink: 'Link kopieren',
    navCopied: '✓ Kopiert',
    navStableLiveLink: 'Permanenter Live-Link',
    langToggle: '🌐',

    // ── HomePage: Hero ──
    heroMicro: 'KI-Karriereseiten-Studio – Für HR-Teams entwickelt',
    heroLine1: 'KARRIERE­',
    heroLine2: 'SEITEN',
    heroLine3: 'IN 30 SEK.',
    heroSub: 'Geben Sie die Stellendetails ein und erhalten Sie eine gebrandete Recruiting-Seite – inkl. Bewerbungsformular – sofort teilbar.',
    statPagesDeployed: 'Seiten erstellt',
    statFillRate: 'Besetzungsrate verbessert',
    statAvgPublish: 'Ø Veröffentlichungszeit',
    statMoreApplicants: 'Mehr Bewerber',

    // ── HomePage: Form stages ──
    formTitle: 'Stellen\u00adbeschreibung',
    formStepOf: 'Schritt {current} von {total}',
    stage1Title: 'Eckdaten',
    stage1Sub: 'Rolle und Rahmenbedingungen',
    stage2Title: 'Inhalt',
    stage2Sub: 'Anforderungen, Benefits und Stil',
    stage3Title: 'Marke & Start',
    stage3Sub: 'Farben, Logo und Anbieter',

    // ── Stage 1 fields ──
    labelJobTitle: 'Stellenbezeichnung',
    placeholderJobTitle: 'z.\u00a0B. Senior React Entwickler',
    labelCompany: 'Unternehmen',
    placeholderCompany: 'Acme GmbH',
    labelSalary: 'Gehaltsspanne',
    placeholderSalary: 'EUR 60.000 – 85.000',
    labelLocation: 'Standort',
    placeholderLocation: 'Berlin / Remote',
    labelSeniority: 'Erfahrungsstufe',
    seniorityJunior: 'Junior',
    seniorityMid: 'Mid-Level',
    senioritySenior: 'Senior',
    seniorityLead: 'Lead / Staff',
    seniorityDirector: 'Direktor',
    labelEmploymentType: 'Anstellungsart',
    typeFull: 'Vollzeit',
    typePart: 'Teilzeit',
    typeContract: 'Freelance / Vertrag',
    typeInternship: 'Praktikum',
    labelWorkMode: 'Arbeitsmodell',
    modeOnsite: 'Vor Ort',
    modeHybrid: 'Hybrid',
    modeRemote: 'Remote',

    // ── Stage 2 fields ──
    labelPageStyle: 'Seitenstil',
    labelRequirements: 'Kernanforderungen',
    placeholderRequirements: 'React, TypeScript, 4+ Jahre Erfahrung, starke Kommunikation…',
    labelQualifications: 'Qualifikationen',
    placeholderQualifications: 'Bachelor in Informatik o. ä., AWS-Zertifizierung, PMP-Zertifizierung von Vorteil…',
    labelEmployerBranding: 'Employer Branding',
    placeholderEmployerBranding: 'Wir sind ein missionsorientiertes Team, das die Zukunft der Arbeit gestaltet. Wachstumsstarke, remote-freundliche Kultur mit viel Eigenverantwortung…',
    labelBenefits: 'Benefits & Vorteile',
    placeholderBenefits: 'Mitarbeiterbeteiligung, flexible Arbeitszeiten, Weiterbildungsbudget, Gesundheitsvorsorge…',

    // ── Stage 3 fields ──
    labelLogoUrl: 'Markenlogo',
    placeholderLogoUrl: 'https://cdn.beispiel.de/logo.png',
    logoUploadBtn: 'Logo hochladen',
    logoUploading: 'Wird hochgeladen…',
    logoUploadHint: 'PNG, JPG, SVG, WebP – max. 5 MB',
    logoChangeBtn: 'Ändern',
    logoRemoveBtn: 'Entfernen',
    logoRequired: 'Markenlogo ist erforderlich. Bitte laden Sie Ihr Unternehmenslogo hoch.',
    labelBrandColors: 'Markenfarben',
    labelDesignLock: 'Design sperren',
    designLockLabel: 'Markenfarben bei Generierung und Bearbeitung beibehalten',
    labelPrimaryColor: 'Primärfarbe',
    labelSecondaryColor: 'Sekundärfarbe',
    labelAccentColor: 'Akzentfarbe',

    // ── Form footer / buttons ──
    footerHint: 'Seite in ca. 30 Sek. online',
    btnBack: '← Zurück',
    btnNextStep: 'Nächster Schritt →',
    btnGenerate: 'Karriereseite erstellen',

    // ── Generation phases ──
    phase1: 'Jobbeschreibung wird geprüft',
    phase2: 'Seitenstruktur wird erstellt',
    phase3: 'Inhalte und Formular werden aufgebaut',
    phase4: 'Markenrichtung wird angewendet',
    phase5: 'Live-Entwurf wird veröffentlicht',

    // ── Morph strip ──
    morphLabel: 'Aktuell gesucht',

    // ── Footer ──
    footerTagline: 'KI-gestützte Karriereseiten, die konvertieren. Für moderne HR-Teams, die schnell handeln.',
    footerProduct: 'Produkt',
    footerResources: 'Ressourcen',
    footerCompany: 'Unternehmen',
    footerAnalytics: 'Analyse',
    footerDocs: 'Dokumentation',
    footerApiRef: 'API-Referenz',
    footerChangelog: 'Änderungsprotokoll',
    footerAbout: 'Über uns',
    footerPrivacy: 'Datenschutzerklärung',
    footerTerms: 'AGB',
    footerImprint: 'Impressum',
    footerCopy: '© 2026 Formly HR · KI-Karriereseiten für Recruiting-Teams',
    footerStatus: 'Alle Systeme betriebsbereit',

    // ── Auth page ──
    authWelcomeBack: 'Willkommen zurück',
    authGetStarted: 'Kostenlos starten',
    authSignBackIn: 'ZURÜCK\nEIN­\nLOGGEN.',
    authBuildPages: 'SEITEN\nSCHNELLER\nERSTELLEN.',
    authTagline: 'Ihre Seiten warten.\nBeschreibungen werden in unter\n30 Sekunden zu Live-Formularen.',
    authPerk1: 'Live-Seite in ca. 30 Sekunden veröffentlicht',
    authPerk2: 'Alles per Chat bearbeiten – kein Code nötig',
    authPerk3: 'Bewerbungen werden automatisch erfasst',
    authPerk4: 'Kostenlos starten. Keine Kreditkarte nötig.',
    authAuthentication: 'Authentifizierung',
    authCreateAccount: 'Konto erstellen',
    authLoginTitle: 'Bei Formly anmelden',
    authSignupTitle: 'Kostenlos loslegen',
    authEmailLabel: 'E-Mail-Adresse',
    authEmailPlaceholder: 'name@unternehmen.de',
    authPasswordLabel: 'Passwort',
    authForgotPassword: 'Passwort vergessen?',
    authPwMin: 'Mind. 8 Zeichen',
    authPwWeak: 'Schwach',
    authPwOkay: 'Okay',
    authPwStrong: 'Stark',
    authPwVeryStrong: 'Sehr stark',
    authResetPasswordSent: 'Wenn die E-Mail existiert, wurde ein Reset-Link gesendet.',
    authResetLinkSent: 'Wenn die E-Mail existiert, wurde ein Reset-Link gesendet.',
    authResetPasswordTitle: 'Passwort zurücksetzen',
    authResetPasswordNote: 'Geben Sie ein neues Passwort ein, um den Reset abzuschließen.',
    authNewPasswordLabel: 'Neues Passwort',
    authNewPasswordPlaceholder: 'Neues Passwort erstellen',
    authConfirmPasswordLabel: 'Passwort bestätigen',
    authConfirmPasswordPlaceholder: 'Passwort erneut eingeben',
    authPasswordMismatch: 'Passwörter stimmen nicht überein.',
    authPasswordResetSuccess: 'Ihr Passwort wurde aktualisiert.',
    authBackToLogin: 'Zurück zum Login',
    authTermsAgree: 'Ich stimme den',
    authTermsOfService: 'Nutzungsbedingungen',
    authPrivacyPolicy: 'Datenschutzrichtlinie',
    authSignIn: 'Anmelden',
    authCreateAccountBtn: 'Konto erstellen',
    authPleaseWait: 'Bitte warten...',
    authOrContinue: 'oder weiter mit',
    authContinueGoogle: 'Weiter mit Google',
    authContinueGithub: 'Weiter mit GitHub',
    authNoAccount: 'Kein Konto?',
    authHaveAccount: 'Bereits ein Konto?',
    authCreateOne: 'Erstellen →',
    authSignInLink: 'Anmelden →',
    authStepAccount: 'Konto',
    authStepDetails: 'Details',
    authStepDone: 'Fertig',
    authStepLabel: 'Schritt {current} von {total} — {label}',

    // ── Editor page ──
    editorLivePreview: 'Live-Vorschau',
    editorLive: '● live',
    editorStableUrl: 'Permanente URL:',
    editorDiffView: 'Änderungen — Diff-Ansicht',
    editorPlaceholder: 'Anderung beschreiben, Medien hochladen oder ein Bild generieren...',
    editorApply: '→ Anwenden',
    editorApplying: 'Wird angewendet...',
    editorOverrideDesignLock: 'Design-Sperre für diese Änderung aufheben',
    editorBrandKit: 'Marken-Kit',
    editorBrandLogoLabel: 'Markenlogo-URL',
    editorBrandLogoPlaceholder: 'https://cdn.beispiel.de/logo.png',
    editorPrimary: 'Primär',
    editorSecondary: 'Sekundär',
    editorAccent: 'Akzent',
    editorKeepBrandLock: 'Markenfarben gesperrt halten',
    editorSaveBrand: 'Marken-Metadaten speichern',
    editorSavingBrand: 'Wird gespeichert...',
    editorMediaAssets: 'Medien-Assets',
    editorUploadImage: 'Bild/Video hochladen',
    editorUploading: '⏳ Wird hochgeladen...',
    editorAiImagePlaceholder: 'Beschreiben Sie ein Bild zur KI-Generierung…',
    editorGenerate: 'Generieren',
    editorClose: 'Schliessen',
    editorNoAssets: 'Noch keine Assets hochgeladen.',
    editorUse: '↗ Einfügen',
    editorRemove: '✕ Entfernen',
    editorInitialMsg: 'Live-Seite geladen. Beschreiben Sie Ihre erste Änderung.',

    // ── CRM page ──
    crmCreateJob: 'Stelle anlegen',
    crmJobTitle: 'Stellenbezeichnung',
    crmCompany: 'Unternehmen',
    crmLocation: 'Standort',
    crmSalaryRange: 'Gehaltsspanne',
    crmSaving: 'Wird gespeichert...',
    crmPipelineSnapshot: 'Pipeline-Übersicht',
    crmCandidates: 'Kandidaten',
    crmAllJobs: 'Alle Stellen',
    crmAllStages: 'Alle Phasen',
    crmClearJobFilter: 'Stellenfilter löschen',
    crmSearchPlaceholder: 'Suche nach Name, E-Mail, Telefon, Seite oder Stelle',
    crmSearch: 'Suchen',
    crmClearSearch: 'Suche löschen',
    crmShowingFor: 'Kandidaten für: {title}',
    crmShowingAll: 'Alle Kandidaten aller Landingpages.',
    crmShowingCount: '{count} von {total} Kandidaten.',
    crmLoading: 'Wird geladen...',
    crmNoCandidates: 'Noch keine Kandidaten. Nutzen Sie das Formular Ihrer erstellten Seite.',
    crmThName: 'Name',
    crmThEmail: 'E-Mail',
    crmThPhone: 'Telefon',
    crmThJob: 'Stelle',
    crmThSourcePage: 'Quellseite',
    crmThLiveUrl: 'Live-URL',
    crmThStage: 'Phase',
    crmOpenPage: 'Seite öffnen',
    crmUnknown: 'Unbekannt',
    crmUnassigned: 'Nicht zugewiesen',
    crmPrev: 'Zurück',
    crmNext: 'Weiter',
    crmPage: 'Seite {current} / {total}',
    crmCandidateDetails: 'Kandidatendetails',
    crmClose: 'Schließen',
    crmLoadingDetails: 'Details werden geladen...',
    crmName: 'Name:',
    crmEmail: 'E-Mail:',
    crmPhone: 'Telefon:',
    crmJob: 'Stelle:',
    crmStage: 'Phase:',
    crmAssignee: 'Zuständig',
    crmAssigneePlaceholder: 'Recruiter-Name oder Verantwortlicher',
    crmNotes: 'Notizen',
    crmNotesPlaceholder: 'Kandidatennotizen hinzufügen',
    crmSaveDetails: 'Details speichern',
    crmTimeline: 'Zeitleiste',
    crmNoEvents: 'Noch keine Ereignisse.',
    crmOriginalPayload: 'Formular-Rohdaten',
    crmJobRequired: 'Stellenbezeichnung ist erforderlich',
    crmJobCreated: 'Stelle erfolgreich erstellt.',
    crmStageUpdated: 'Kandidatenphase aktualisiert.',
    crmDetailsSaved: 'Kandidatendetails gespeichert.',

    // ── Meta Campaign page ──
    metaTotalCampaigns: 'Kampagnen gesamt',
    metaActiveNow: 'Derzeit aktiv',
    metaCombinedBudget: 'Tagesbudget gesamt',
    metaLandingPagesLinked: 'Verknüpfte Landingpages',
    metaNewCampaign: 'Neue Kampagne',
    metaDescription: 'Verbinden Sie eine Landingpage mit Facebook- und Instagram-Anzeigen. KI erstellt automatisch Anzeigentexte aus Ihrer Seitenbeschreibung.',
    metaLandingPage: 'Landingpage',
    metaSelectPage: 'Seite auswählen…',
    metaOrPasteUuid: 'Oder Seiten-UUID einfügen',
    metaCampaignName: 'Kampagnenname',
    metaCampaignNamePlaceholder: 'z.\u00a0B. Senior Engineer — Q2 Recruiting',
    metaAdAccountId: 'Werbekonto-ID',
    metaAdAccountPlaceholder: 'Numerische ID (ohne act_)',
    metaFbPageId: 'Facebook-Seiten-ID',
    metaFbPagePlaceholder: 'Ihre FB-Business-Seiten-ID',
    metaAccessToken: 'Zugriffstoken',
    metaAccessTokenPlaceholder: 'Meta ads_management Token',
    metaObjective: 'Ziel',
    metaDailyBudget: 'Tagesbudget',
    metaLaunchStatus: 'Startstatus',
    metaPaused: 'Pausiert — erst prüfen',
    metaActive: 'Aktiv — sofort starten',
    metaAiForAdCopy: 'KI für Anzeigentexte',
    metaLaunchCampaign: 'Kampagne starten',
    metaCreatingOnMeta: 'Wird bei Meta erstellt…',
    metaCampaignHistory: 'Kampagnenverlauf',
    metaNoCampaigns: 'Noch keine Kampagnen. Erstellen Sie Ihre erste oben.',
    metaAiAdCopy: 'KI-generierter Anzeigentext',
    metaHeadline: 'Überschrift',
    metaPrimaryText: 'Haupttext',
    metaAdDescription: 'Beschreibung',
    metaCampaignId: 'Meta-Kampagnen-ID',
    metaAdSetId: 'Anzeigengruppen-ID',
    metaAdId: 'Anzeigen-ID',
    metaAdAccount: 'Werbekonto',
    metaAdCopy: 'Anzeigentext',
    metaCreatedSuccess: 'Kampagne bei Meta erstellt — prüfen Sie Ihren Werbeanzeigenmanager.',
    metaCreatedFail: 'Kampagnenerstellung fehlgeschlagen',
    metaLeadGen: 'Leadgenerierung',
    metaTraffic: 'Traffic',
    metaBrandAwareness: 'Markenbekanntheit',
    metaTargetCountries: 'Zielländer',
    metaTargetCountriesPlaceholder: 'DE, AT, CH',
    metaTargetCountriesHint: 'ISO-2-Ländercodes, kommagetrennt (z.\u00a0B. DE, AT, CH)',

    // ── CRM redesign ──
    crmMyDashboard: 'Mein Dashboard',
    crmMyLandingPages: 'Meine Landingpages',
    crmStatusPublished: 'Veröffentlicht',
    crmStatusInReview: 'In Prüfung',
    crmStatusPending: 'Ausstehend',
    crmStepSubmitted: 'Anfrage gestellt',
    crmStepReviewing: 'Admin prüft',
    crmStepLive: 'Seite live',
    crmTotalRequests: 'Anfragen gesamt',
    crmStatusBreakdown: 'Statusübersicht',
    crmLoadingPages: 'Seiten werden geladen…',
    crmNoRequests: 'Noch keine Anfragen',
    crmNoRequestsDesc: 'Stellen Sie eine Landingpage-Anfrage und verfolgen Sie sie hier.',
    crmSubmitFirstRequest: 'Erste Anfrage stellen →',
    crmNewRequest: '+ Neue Anfrage',
    crmViewPage: 'Seite ansehen ↗',
    crmSubmitDate: 'Eingereicht am',
    crmChartTotal: 'gesamt',

    // ── Admin login ──
    adminPanelSub: 'Admin-Bereich',
    adminEmail: 'E-Mail',
    adminPassword: 'Passwort',
    adminSignIn: 'Anmelden',
    adminSigningIn: 'Anmeldung läuft…',

    // ── Admin dashboard ──
    adminPendingRequests: 'Ausstehende Anfragen',
    adminDraftPages: 'Entwurfsseiten',
    adminPublished: 'Veröffentlicht',
    adminTotalPages: 'Seiten gesamt',
    adminTabRequests: 'Seitenanfragen',
    adminTabPages: 'Alle Seiten',
    adminTabCandidates: 'Kandidaten',
    adminTabAnalytics: 'Analyse',
    adminAnalyticsTotalViews: 'Aufrufe gesamt',
    adminAnalyticsUniqueVisitors: 'Eindeutige Besucher',
    adminAnalyticsToday: 'Aufrufe heute',
    adminAnalytics7d: 'Aufrufe (7 Tage)',
    adminAnalyticsPageBreakdown: 'Seitenübersicht',
    adminAnalyticsLast7Days: 'Tägliche Aufrufe — letzte 7 Tage',
    adminAnalyticsNoData: 'Noch keine Besuche aufgezeichnet. Teilen Sie Ihre veröffentlichten Seiten, um das Tracking zu starten.',
    adminAnalyticsColPage: 'Seite',
    adminAnalyticsColUser: 'Inhaber',
    adminAnalyticsColTotal: 'Aufrufe gesamt',
    adminAnalyticsColUnique: 'Eindeutige Besucher',
    adminAnalyticsColToday: 'Heute',
    adminAnalyticsCol7d: '7 Tage',
    adminLoading: 'Wird geladen…',
    adminGenerate: 'Generieren',
    adminGenerating: 'Wird generiert…',
    adminDelete: 'Löschen',
    adminEdit: 'Bearbeiten',
    adminPublish: 'Veröffentlichen',
    adminUnpublish: 'Zurückziehen',
    adminRefresh: 'Aktualisieren',
    adminExportCsv: 'CSV exportieren',
    adminExportJson: 'JSON exportieren',
    adminNoRequests: 'Keine ausstehenden Anfragen.',
    adminNoPages: 'Keine Seiten gefunden',
    adminNoCandidates: 'Noch keine Kandidaten.',
    adminSearchPlaceholder: 'Nach Beschreibung oder E-Mail suchen…',
    adminCandSearchPlaceholder: 'Nach Name, E-Mail, Telefon oder Stelle suchen…',
    adminSearch: 'Suchen',
    adminClearSearch: 'Löschen',
    adminPrev: '← Zurück',
    adminNext: 'Weiter →',
    adminColNum: '#',
    adminColUser: 'Benutzer',
    adminColDescription: 'Beschreibung',
    adminColStatus: 'Status',
    adminColCreated: 'Erstellt',
    adminColLiveUrl: 'Live-URL',
    adminColActions: 'Aktionen',
    adminColName: 'Name',
    adminColEmail: 'E-Mail',
    adminColPhone: 'Telefon',
    adminColJob: 'Stelle',
    adminColApplied: 'Beworben',
    adminColStage: 'Phase',
    adminOpenPage: 'Öffnen ↗',
    adminCandidateDetails: 'Kandidatendetails',
    adminClose: 'Schließen ✕',
    adminNotes: 'Notizen:',
    adminTimeline: 'ZEITLEISTE',
    adminLogout: 'Abmelden',
    adminNavPages: 'Seiten',
    adminNavPending: 'ausstehend',
    adminToastPublished: 'Seite veröffentlicht! Nutzer kann sie jetzt ansehen.',
    adminToastUnpublished: 'Seite auf Entwurf zurückgesetzt.',
    adminToastDeleted: 'Seite gelöscht',
    adminConfirmDelete: 'Diese Seite löschen? Dies kann nicht rückgängig gemacht werden.',
    adminPageOf: 'Seite {page} · {total} gesamt',

    // ── HomePage success state ──
    homeRequestSubmitted: 'Anfrage eingereicht!',
    homeRequestBody: 'Ihre Landingpage-Anfrage wurde empfangen. Der Admin prüft und veröffentlicht sie in Kürze.',
    homeSubmitAnother: 'Weitere Anfrage',
    homeViewInCrm: 'Im CRM ansehen →',
    homeSubmittingRequest: 'Anfrage wird gesendet…',
  },
};

export default translations;
